import { observable, runInAction } from 'mobx';
import { IProductionPlanningServices, ProductionPlanningReport } from 'services/productionPlanning_services';
import { DataResponse } from 'services/response';

export type ProductStore = {
  dataTable: DataResponse<ProductionPlanningReport[]>
};

export interface IProductionPlanningPresenter {
  createStore(): ProductStore;
  searchReport(store: ProductStore, data: object): Promise<void>;
  exportExcel(data: object): Promise<void>;


}

export function createProductionPlanningPresenter(
  {
    productionPlanningServices,
  }: {
    productionPlanningServices: IProductionPlanningServices;
  }
): IProductionPlanningPresenter {
  return {
    createStore: (): ProductStore =>
      observable({
        //khoi tao gtri ban dau
        dataTable: {
          data: [],
          message: '',
          isSuccess: false,
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        }
      }),

    searchReport: async (store, data) => {
      try {
        const result = await productionPlanningServices.getListReport(data);
        runInAction(() => {
          store.dataTable.data = result.data;
          store.dataTable.message = result.message;
          store.dataTable.isSuccess = result.isSuccess;
          store.dataTable.pagesCount = result.pagesCount;
          store.dataTable.paging = result.paging;
          store.dataTable.recordsTotal = result.recordsTotal;
          store.dataTable.resultsCount = result.resultsCount;
        });
      } catch (error) {
        console.log(error);
      }
    },
    exportExcel: async (data: object) => {
      try {
        await productionPlanningServices.exportExcel(data);
      } catch (error) {
        console.log(error);
      }
    },

  };
}
